import { ENV } from "../utils";

export class InjuryNature {
  baseApi = ENV.BASE_API;

  async getInjuryNatures(active) {
    const url = active !== undefined
      ? `${this.baseApi}/injury-natures?active=${active}`
      : `${this.baseApi}/injury-natures`;
    const params = { method: "GET", headers: { "Content-Type": "application/json", Authorization: `Bearer ${localStorage.getItem("access")}` } };
    const res = await fetch(url, params);
    const result = await res.json();
    if (res.status !== 200) throw result;
    return result;
  }

  async createInjuryNature(data) {
    const url = `${this.baseApi}/add-injury-nature`;
    const params = { method: "POST", headers: { "Content-Type": "application/json", Authorization: `Bearer ${localStorage.getItem("access")}` }, body: JSON.stringify(data) };
    const res = await fetch(url, params);
    const result = await res.json();
    if (res.status !== 200) throw result;
    return result;
  }

  async updateInjuryNature(id, data) {
    const url = `${this.baseApi}/update-injury-nature/${id}`;
    const params = { method: "PUT", headers: { "Content-Type": "application/json", Authorization: `Bearer ${localStorage.getItem("access")}` }, body: JSON.stringify(data) };
    const res = await fetch(url, params);
    const result = await res.json();
    if (res.status !== 200) throw result;
    return result;
  }

  async deleteInjuryNature(id) {
    const url = `${this.baseApi}/delete-injury-nature/${id}`;
    const params = { method: "DELETE", headers: { "Content-Type": "application/json", Authorization: `Bearer ${localStorage.getItem("access")}` } };
    const res = await fetch(url, params);
    const result = await res.json();
    if (res.status !== 200) throw result;
    return result;
  }
}
